module.exports = __webpack_public_path__ + "img/man-bird-frame.3c34dd30.png";